export enum DataClassification {
  // tslint:disable:no-bitwise
  EssentialServiceMetadata = 1 << 0,
  AccountData = 1 << 1,
  SystemMetadata = 1 << 2,
  OrganizationIdentifiableInformation = 1 << 3,
  EndUserIdentifiableInformation = 1 << 4,
  CustomerContent = 1 << 5,
  AccessControl = 1 << 6
}
